import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import * as S from "./styles";
import { useReport } from "./useReport";
import { Input } from "../../Atoms/Inputs/Input";
import { TextArea } from "../../Atoms/TextArea";
import { InputCheck } from "../../Atoms/Inputs/InputCheck";
import { FileReport } from "../../Atoms/FileReport";
import dayjs from "dayjs";
import { getMedidaPreventiva } from "../../../utils/getMedidaPreventiva";
import { MEDIDAS_PREVENTIVAS } from "../../../constants/medidas_preventivas";
import { InputCheckbox } from "../../Atoms/Inputs/InputCheckbox/inputCheckbox";

export const Report = () => {
  const { navigate, denuncia, downloadArquivo } = useReport();

  return (
    <LayoutTemplate>
      <S.Container>
        <h1>Dados da Denúncia</h1>

        <section>
          <div>
            <S.SectionTitle>Dados do Colaborador</S.SectionTitle>
          </div>
          {denuncia?.nomeColaborador !== "" ? (
            <S.Grid1>
              <div>
                <Input
                  label="Nome"
                  value={denuncia?.nomeColaborador}
                  disabled
                />
              </div>
              <div>
                <Input
                  label="Data de Admissão"
                  value={dayjs(denuncia.dataAdmissao).format("DD/MM/YYYY")}
                  disabled
                />
              </div>
              <div>
                <Input
                  label="Cargo"
                  value={denuncia?.cargoColaborador}
                  disabled
                />
              </div>
              <div>
                <Input
                  label="Setor/Departamento/Empresa"
                  value={denuncia?.setorColaborador}
                  disabled
                />
              </div>
            </S.Grid1>
          ) : (
            <S.Anonimo>
              <div>
                <InputCheckbox
                  checked={true}
                  onChange={(e) => {
                    const check = e.target.checked;
                  }}
                  disabled={true}
                  label="Denunciado Anonimamente"
                />
              </div>
            </S.Anonimo>
          )}
        </section>

        <section>
          <div>
            <S.SectionTitle>Dados do Acusado</S.SectionTitle>
          </div>
          <S.Grid1>
            <div>
              <Input label="Nome" value={denuncia?.nomeAcusado} disabled />
            </div>
            <div>
              <Input label="Cargo" value={denuncia?.cargoAcusado} disabled />
            </div>
            <div>
              <Input
                label="Setor/Departamento/Empresa"
                value={"Operações"}
                disabled
              />
            </div>
            <div>
              <Input
                label="Tipo de Assédio"
                value={denuncia?.tipoAssedio}
                disabled
              />
            </div>
          </S.Grid1>
        </section>

        <section>
          <div>
            <S.SectionTitle>Descrição</S.SectionTitle>
          </div>

          <S.Grid2>
            <div>
              <Input
                label="Data"
                value={dayjs(denuncia?.dataOcorrencia).format("DD/MM/YYYY")}
                disabled
              />
            </div>
            <div>
              <Input label="Local" value={denuncia?.localizacao} disabled />
            </div>
            <div>
              <TextArea
                style={{ height: "250px" }}
                label="Descrição do Assédio"
                value={denuncia?.descricao}
                disabled
              />
            </div>
          </S.Grid2>
        </section>

        {denuncia?.testemunhas?.length > 0 && (
          <section>
            <div>
              <S.SectionTitle>Testemunhas</S.SectionTitle>
            </div>

            <S.Grid3>
              {denuncia?.testemunhas?.map((testemunha) => (
                <S.Card key={testemunha?.uuid}>
                  <p>
                    Nome: <span>{testemunha?.nome}</span>
                  </p>
                  <p>
                    Cargo: <span>{testemunha?.cargo}</span>
                  </p>
                </S.Card>
              ))}
            </S.Grid3>
          </section>
        )}

        <section>
          <div>
            <S.SectionTitle>Medidas Tomadas</S.SectionTitle>
          </div>

          <S.FlexItems>
            <S.Flex>
              <div>
                <p>Procurou um superior?</p>
              </div>
              <div>
                <InputCheck
                  checked={denuncia?.procurouSuperior}
                  disabled
                  text={"Sim"}
                />
              </div>
              <div>
                <InputCheck
                  disabled
                  checked={denuncia?.procurouSuperior === false}
                  text={"Não"}
                />
              </div>
              {denuncia?.procurouSuperior && (
                <div style={{ width: "100%" }}>
                  <Input disabled value={denuncia?.nomeSuperior} />
                </div>
              )}
            </S.Flex>

            <S.Flex>
              <div>
                <p>Informou o RH?</p>
              </div>
              <div>
                <InputCheck
                  checked={denuncia?.informouRh}
                  disabled
                  text={"Sim"}
                />
              </div>
              <div>
                <InputCheck
                  checked={denuncia?.informouRh === false}
                  disabled
                  text={"Não"}
                />
              </div>
            </S.Flex>

            <S.Flex>
              <div>
                <p>Registrou Boletim de Ocorrência (B.O.)?</p>
              </div>
              <div>
                <InputCheck
                  checked={denuncia?.registrouBo}
                  disabled
                  text={"Sim"}
                />
              </div>
              <div>
                <InputCheck
                  disabled
                  checked={denuncia?.registrouBo === false}
                  text={"Não"}
                />
              </div>
            </S.Flex>

            <div>
              <TextArea
                disabled
                label="Outras medidas Tomadas"
                style={{ height: "250px" }}
                value={denuncia?.outrasAcoes}
              />
            </div>
          </S.FlexItems>
        </section>

        <section>
          <div>
            <S.SectionTitle>Solicitação</S.SectionTitle>
          </div>

          <S.Flex1>
            <div>
              <Input
                label="Demanda"
                value={
                  denuncia?.demanda
                    ? getMedidaPreventiva(
                        denuncia.demanda as keyof typeof MEDIDAS_PREVENTIVAS
                      )
                    : ""
                }
                disabled
              />
            </div>
            <div>
              <TextArea
                style={{ height: "250px" }}
                label="Outras Solicitações"
                value={denuncia?.outrasSolicitacoes}
                disabled
              />
            </div>
          </S.Flex1>
        </section>

        {denuncia?.arquivos?.length > 0 && (
          <section>
            <div>
              <S.SectionTitle>Arquivos Anexados</S.SectionTitle>
            </div>

            <S.Flex2>
              {denuncia?.arquivos?.map((file) => (
                <FileReport
                  title={file.fileName}
                  key={file.uuid}
                  file={file}
                  onClick={() => downloadArquivo(file)}
                />
              ))}
            </S.Flex2>
          </section>
        )}
      </S.Container>
      <S.ToBack type="button" onClick={() => navigate(-1)}>
        Voltar
      </S.ToBack>
    </LayoutTemplate>
  );
};
